module.exports = __webpack_public_path__ + "img/banner1.3087cf58.png";